import moment from "moment";

export const parseQueryParams = (search: string): Record<string, string> => {
  const queryParams = new URLSearchParams(search);
  const params: Record<string, string> = {};

  queryParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

export const checkAcessRights = (route: string, rightID: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  return userResponse
    ?.find((e: any) => e.MenuKey === route?.substring(1))
    ?.RightsID?.includes(rightID);
};

export const hasRights = (menuKey: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const menu = userResponse.find((item) => item.MenuKey === menuKey);
  return menu && menu.RightsID;
};

export const getFilterFromToDate = (SelectedDate: number) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const weekStart = new Date(today);
  weekStart.setDate(today.getDate() - today.getDay());
  const last30Days = new Date(today);
  last30Days.setDate(today.getDate() - 30);
  const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);

  const formate = (date: Date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  switch (SelectedDate) {
    case 1:
      return { FromDate: formate(today), ToDate: formate(today) };
    case 2:
      return {
        FromDate: formate(yesterday),
        ToDate: formate(yesterday),
      };
    case 3:
      return {
        FromDate: formate(weekStart),
        ToDate: formate(today),
      };
    case 4:
      return {
        FromDate: formate(last30Days),
        ToDate: formate(today),
      };
    case 5:
      return {
        FromDate: formate(monthStart),
        ToDate: formate(today),
      };
    default:
      return {
        FromDate: "",
        ToDate: "",
      };
  }
};

export function formatIndianNumber(number: number, decimal: any = 2): string {
  if (number === null || number === undefined) return "";
  let [integerPart, decimalPart] = number.toFixed(decimal).split(".");
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return formattedOtherDigits + lastThreeDigits + "." + decimalPart;
}

export const getLocalStorageData = (item: string) => {
  return localStorage.getItem(item);
};

export function convertToIndianWords(number: any) {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  let words = "";
  if (number === 0) {
    return "Zero";
  }
  if (Math.floor(number / 10000000) > 0) {
    words += convertToIndianWords(Math.floor(number / 10000000)) + " Crore ";
    number %= 10000000;
  }
  if (Math.floor(number / 100000) > 0) {
    words += convertToIndianWords(Math.floor(number / 100000)) + " Lakh ";
    number %= 100000;
  }
  if (Math.floor(number / 1000) > 0) {
    words += convertToIndianWords(Math.floor(number / 1000)) + " Thousand ";
    number %= 1000;
  }
  if (Math.floor(number / 100) > 0) {
    words += convertToIndianWords(Math.floor(number / 100)) + " Hundred ";
    number %= 100;
  }
  if (number > 0) {
    if (words !== "") {
      words += "and ";
    }
    if (number < 10) {
      words += ones[number];
    } else if (number < 20) {
      words += teens[number - 10];
    } else {
      words += tens[Math.floor(number / 10)];
      if (number % 10 > 0) {
        words += " " + ones[number % 10];
      }
    }
  }
  return words;
}

export function calculateDuration(
  departureDate: string,
  departureTime: string,
  arrivalDate: string,
  arrivalTime: string
): string {
  const departure = new Date(`${departureDate}T${departureTime}`);
  const arrival = new Date(`${arrivalDate}T${arrivalTime}`);

  const diffMs = arrival.getTime() - departure.getTime();

  if (diffMs < 0) {
    return "-";
  }

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  let result = "";
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}m`;

  return result.trim() || "0m";
}

export function generateValueLabelRange<T extends number | string>(
  start: number,
  end: number,
  as: "number" | "string"
): { value: T; label: T }[] {
  const result: { value: T; label: T }[] = [];

  for (let i = start; i <= end; i++) {
    const val = (as === "string" ? String(i) : i) as T;
    result.push({ value: val, label: val });
  }

  return result;
}
